import { render, staticRenderFns } from "./TasksTab.vue?vue&type=template&id=4c5078f6&"
import script from "./TasksTab.vue?vue&type=script&lang=js&"
export * from "./TasksTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports